import type { ReactNode } from 'react';

// Small layout primitives shared across /rating page sections. Extracted so
// the page orchestrator stays under the god-file threshold; each one is
// presentation-only with no state of its own.

export function Card({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="border border-[#1e293b] rounded-lg bg-[#0f1623] p-5">
      <div className="text-[11px] uppercase tracking-wider text-[var(--gold)] font-semibold mb-3">
        {title}
      </div>
      <div className="space-y-1.5">{children}</div>
    </div>
  );
}

export function Row({ k, v, highlight }: { k: string; v: string; highlight?: boolean }) {
  return (
    <div className="flex items-baseline justify-between gap-3 text-[12px]">
      <span className="text-[#94a3b8]">{k}</span>
      <span className={highlight ? 'text-emerald-300 font-semibold' : 'text-[#e2e8f0] font-mono'}>
        {v}
      </span>
    </div>
  );
}

export function Stat({ label, value, good }: { label: string; value: string; good?: boolean }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[10px] uppercase tracking-wider text-[#64748b]">{label}</span>
      <span className={`text-[20px] font-semibold ${good ? 'text-emerald-300' : 'text-[#e2e8f0]'}`}>
        {value}
      </span>
    </div>
  );
}

export function Surface({ tag, title, children }: { tag: string; title: string; children: ReactNode }) {
  return (
    <div className="border border-[#1e293b] rounded-lg bg-[#0f1623] p-5">
      <div className="text-[9px] uppercase tracking-[0.14em] text-[var(--gold)] font-bold mb-1">{tag}</div>
      <h3 className="text-[15px] font-semibold text-white mb-2">{title}</h3>
      <p className="text-[12px] text-[#cbd5e1] leading-relaxed">{children}</p>
    </div>
  );
}

export function PillarStat({ label, value, sub }: { label: string; value: string; sub: string }) {
  return (
    <div className="border border-[#1e293b] rounded-lg bg-[#0f1623] p-3">
      <div className="text-[9px] uppercase tracking-[0.12em] text-[#64748b] font-semibold">{label}</div>
      <div className="text-[22px] font-bold text-[var(--gold)] mt-1 leading-none">{value}</div>
      <div className="text-[10px] text-[#94a3b8] mt-1">{sub}</div>
    </div>
  );
}

export function PipelineCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="border border-[#1e293b] rounded-lg bg-[#0f1623] p-5">
      <h3 className="text-[12px] uppercase tracking-wider text-[var(--gold)] font-semibold mb-2">{title}</h3>
      <p className="text-[12px] text-[#cbd5e1] leading-relaxed">{children}</p>
    </div>
  );
}
